import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';

export function setAguardando(aguardando) {
    return {
        type: 'DASHBOARD_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getListaAgrupadoPorSituacao(filtro) {
	const request = axios.get(`${consts.API_URL}/pedido/listarAgrupadoPorSituacao`);
	return {
		type: 'DASHBOARD_POR_SITUACAO_LISTADO',
		payload: request
	};
}

export function getListaAgrupadoPorStatus(filtro) {
	const request = axios.get(`${consts.API_URL}/pedido/listarAgrupadoPorStatus`);
	return {
		type: 'DASHBOARD_POR_STATUS_LISTADO',
		payload: request
	};
}

export function getListaPorVencimento(filtro) {
	const request = axios.get(`${consts.API_URL}/pedido/listarPorVencimento`);
	return {
		type: 'DASHBOARD_POR_VENCIMENTO_LISTADO',
		payload: request
	};
}
